const checkIsInAutopassApp = (): boolean => {
  try {
    const useragent = navigator.userAgent;
    const regex = new RegExp('Autopass/(.*)', 'ig');
    const isInAutopassApp = Boolean(useragent.match(regex));
    return isInAutopassApp;
  } catch {
    return false;
  }
};

export { checkIsInAutopassApp };
